import { createFileRoute } from "@tanstack/react-router";
import { LoginComponent } from "../components/Routing/Login";

export const Route = createFileRoute("/login")({
  component: LoginComponent,
  staticData: { titleKey: "common.signIn" },
});
